module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qiniu-uploader-wrapper",
    attrs: {
      "id": "qiniu-uploader-wrapper"
    }
  }, [_c('el-button', {
    attrs: {
      "id": "qiniu-uploader-btn",
      "type": _vm.btnType,
      "plain": _vm.btnPlain,
      "size": "large",
      "disabled": _vm.onUploading
    }
  }, [_vm._v("\n    " + _vm._s(_vm.onUploading ? _vm.onUploadingLabel : _vm.label) + "\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e794c6a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/qiniu_uploader.input.vue
// module id = 923
// module chunks = 3